import { createContext } from 'react';
export var ZoomContext = /*#__PURE__*/createContext({
  scale: 1
});